import { render, staticRenderFns } from "./StudentItem.vue?vue&type=template&id=d4bb961e"
import script from "./StudentItem.vue?vue&type=script&lang=js"
export * from "./StudentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports